// See (http://api.jqueryui.com/datepicker/) for datepicker API
// todo: (maybe?) allow multiple calendars per page
const $ = require('jquery');
const datepicker = require('jquery-ui/ui/widgets/datepicker');
const angular = require('angular');

const datesUtil = require('util/date');

let container = undefined;

let userOpened = false;

let clearFilterDate;


// $scope
let scope = undefined;
// copy of the Calendar.js controller
let model = undefined;

let tempStart = '';

// local copies of what the model is storing

let localRange = {
    start: null,
    end: null,
};

// var __picker = $.fn.datepicker;

// $.fn.datepicker = function(options) {
//     __picker.apply(this, [options]);
// }

function selectedRange(start, end) {

    let clearInputs = start === null && end === null;

    if (clearInputs) {
        localRange = {
            start: null,
            end: null,
        };
    } else {

        if (end.isBefore(start)) {
            let temp = start;
            start = end;
            end = temp;
        }

        localRange = {
            start: start.startOf('day'),
            end: end.endOf('day'),
        };


    }
        
    scope.vm.changeSelection(localRange);
    if (scope.$parent && scope.$parent.vm && scope.$parent.vm.updateDates) {
        scope.$parent.vm.updateDates(localRange);
    }
    if(localRange.start === null && localRange.end === null) {
        clearFilterDate.hide();
    } else {
        clearFilterDate.show();
    }

    updateInputs(clearInputs, true);
}

function updateInputs(clearInputs, force) {

    // update input boxes
    // todo: fix/update. it would be ideal to just use `input type=date` here
    // but they have their own browser specific date pickers which would
    // interfere with ours...hmmm

    // todo: can probably pull out the styling a bit too

    // only update text fields if user has previously opened the calendar
    // this way they don't get set to value when the page (and calendar) loads
    // console.log(userOpened)

    if (clearInputs) {
        document.querySelectorAll('.js-calendar-from').forEach(x => {
            x.querySelector('.filter-panel__date-text').textContent = 'mm/dd/yyy';
        });
        document.querySelectorAll('.js-calendar-to').forEach(x => {
            x.querySelector('.filter-panel__date-text').textContent = 'mm/dd/yyy';
        });
        container.datepicker('refresh');
    } else {
        if(userOpened || force) {
            let format = 'M / D / YYYY'
            document.querySelectorAll('.js-calendar-from').forEach(x => {
                x.querySelector('.filter-panel__date-text').textContent = localRange.start.format(format);
            });
            document.querySelectorAll('.js-calendar-to').forEach(x => {
                x.querySelector('.filter-panel__date-text').textContent = localRange.end.format(format);
            });
        }
    }


}

function onSelect(dateText) {
    let dateMoment = datesUtil.moment(dateText);

    if (tempStart) {
        // range has been selected
        selectedRange(tempStart, dateMoment);
        tempStart = '';
    } else {
        tempStart = dateMoment;
    }
}

function beforeShowDay(dateText) {
    if (!scope) return [false, '', ''];

    // Sets the time to 04:00 so as to reduce risk of timezone issues
    let date = datesUtil.moment((dateText + '').replace(/00:00:00 .*/, '04:00:00'));

    let css = [];

    if (localRange.start && localRange.end) {
        if (date.isSameOrAfter(localRange.start, 'day') && date.isSameOrBefore(localRange.end, 'day')) {
            css.push('ui-datepicker-date-in-range');

            if (localRange.start.isSame(localRange.end, 'day')) {
                css.push('ui-datepicker-date-single-range');
            } else {
                if (date.isSame(localRange.start, 'day')) css.push('ui-datepicker-date-start-range');
                if (date.isSame(localRange.end, 'day')) css.push('ui-datepicker-date-end-range');
            }
        } else {
            css.push('ui-datepicker-date-outside-range');
        }
    }

    return [
        true,   // is date selectable
        css.join(' '),     // css class to add to date
        '',     // tooltip for date
    ];
}

function refresh(options) {
    if (options) {
        if (options.numberOfMonths) container.datepicker("option", { numberOfMonths: options.numberOfMonths });
        if (options.minDate) container.datepicker("option", { minDate: options.minDate });
        if (options.maxDate) container.datepicker("option", { maxDate: options.maxDate });
    }

    if (
        model &&
        model.selectedRange &&
        model.selectedRange.start &&
        model.selectedRange.end &&
        !(
            model.selectedRange.start.isSame(localRange.start) &&
            model.selectedRange.end.isSame(localRange.end)
        )
    ) {
        localRange = model.selectedRange;
    }

    container.datepicker('refresh');
    updateInputs();
}

function init() {
    container = $('.calendar__container');
    container.datepicker({
        // minDate: 0,
        // maxDate: +120,
        dayNamesMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
        firstDay: 1,
        dateFormat: datepicker.ATOM,
        prevText: '<',
        nextText: '>',
        // numberOfMonths: 1,

        onSelect: onSelect,
        beforeShowDay: beforeShowDay,
        selectedRange: selectedRange // we can call this from the angular controller by getting the instance and calling settings.selectedRange() on it
        
    });

    clearFilterDate = $('.clear-filters__date');
    clearFilterDate.hide();

    polyfillClosest();

    function onClick(event) {
        if (event.target.closest('.ui-datepicker-title')) {
            event.target.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }

        if (event.target.closest('.clear-filters__date')) {
            selectedRange(null, null);
        }

        if (event.target.closest('.js-open-calendar')) {
            let box = event.target.closest('.js-open-calendar')
            let bodyRect = document.querySelector('.filter-panel-container').getBoundingClientRect();
            let elemRect = box.getBoundingClientRect();
            let offsetX = elemRect.top - bodyRect.top;
            let offsetY = elemRect.left - bodyRect.left;

            userOpened = true;
            let calendar = document.querySelector('.calendar')
            calendar.classList.add('calendar--enabled');
            calendar.style.left = offsetY + 'px';
            calendar.style.top = (offsetX + elemRect.height + 10) + 'px';

            // document.body.classList.add('u-fixed');
        } else if (!event.target.closest('.calendar')) {
            if(!event.target.closest('.ui-datepicker-header')) {
                let calElement = document.querySelector('.calendar');
                if (calElement){
                    calElement.classList.remove('calendar--enabled');
                }
            }
            // document.body.classList.remove('u-fixed');
        }


        if (event.target.closest('.js-close-calendar')) {
            document.querySelector('.calendar').classList.remove('calendar--enabled');
            document.body.classList.remove('u-fixed');
        }
    }

    document.addEventListener('click', onClick)

    let interval = setInterval(() => {
        scope = angular.element(document.querySelector('.calendar')).scope()
        if (scope && scope.vm) {
            model = scope.vm;
            scope.refresh = refresh;
            scope.refresh()
            clearInterval(interval);
        }

    }, 100);

}

function polyfillClosest() {
    if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    }

    if (!Element.prototype.closest) {
        Element.prototype.closest = function (s) {
            var el = this;
            if (!document.documentElement.contains(el)) return null;
            do {
                if (el.matches(s)) return el;
                el = el.parentElement || el.parentNode;
            } while (el !== null && el.nodeType === 1);
            return null;
        };
    }
}

module.exports = {
    init
}



// WEBPACK FOOTER //
// ./modules/calendar.js